import { defineMessages } from 'react-intl';

export default defineMessages({
    locationBuildingSummaryTitle: {
        id: 'wmic.pe-capability-quoteandbind-common-react.pages.location-info.locationbuilding-summary-title',
        defaultMessage: 'Locations & Buildings Summary',
    },
});
